import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setPorkHerdDetails, setPorkHerdDetailsAdmin } from "services";

import { footprintingPorkPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PORK_HERD_DETAILS } from "consts";

import { FootprintingPorkHerdDetails } from "models";

export const useMutateFootprintingPorkHerdDetails = (
  farmId: string,
  year: number,
  payload: Partial<Omit<FootprintingPorkHerdDetails, "id" | "primaryDataId">>,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FOOTPRINTING_PORK_HERD_DETAILS, primaryDataId, isAdmin],
    mutationFn: () => (isAdmin ? setPorkHerdDetailsAdmin(payload, primaryDataId ?? "") : setPorkHerdDetails(payload, primaryDataId ?? "")),
    onSuccess: async () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_PORK_HERD_DETAILS, primaryDataId, isAdmin],
        [FOOTPRINTING_PORK_HERD_DETAILS, farmId, year, isAdmin],
        ...footprintingPorkPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
      ]);
    },
  });
};
